module.exports = __webpack_public_path__ + "img/a-bg1.af399d35.png";